var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.506,
    height: 49.506,
    viewBox: "0 0 49.506 49.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "all_elements_icons_48px_wallet",
    "data-name": "all / elements / icons / 48px wallet",
    transform: "translate(0.753 0.753)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3920",
    "data-name": "Group 3920",
    transform: "translate(-582.746 -244.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M598.733,262.552a3.167,3.167,0,0,0-3.181,3.152v10.5a3.166,3.166,0,0,0,3.181,3.151h18.026a3.166,3.166,0,0,0,3.18-3.152V265.7a3.165,3.165,0,0,0-3.18-3.151Z",
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M619.939,267.824H617.16a3.131,3.131,0,0,0-3.131,3.132h0a3.131,3.131,0,0,0,3.131,3.131h2.779m-21.091-11.535,10.879-5.88a3.17,3.17,0,0,1,4.3,1.283c.018.032.035.065.051.1l2.241,4.5m-9.582,0,7.373-3.993",
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M595.577,265.518v-1.044a5.226,5.226,0,0,1,5.234-5.217h3.58m15.548,6.261v-1.044a5.246,5.246,0,0,0-5.273-5.217",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWalletIcon);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OS41MDYiIGhlaWdodD0iNDkuNTA2IiB2aWV3Qm94PSIwIDAgNDkuNTA2IDQ5LjUwNiI+CiAgPGcgaWQ9ImFsbF9lbGVtZW50c19pY29uc180OHB4X3dhbGxldCIgZGF0YS1uYW1lPSJhbGwgLyBlbGVtZW50cyAvIGljb25zIC8gNDhweCB3YWxsZXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNzUzIDAuNzUzKSI+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzEwOSIgZGF0YS1uYW1lPSJFbGxpcHNlIDEwOSIgY3g9IjI0IiBjeT0iMjQiIHI9IjI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNlNjJhMzIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIxLjUwNiIvPgogICAgPGcgaWQ9Ikdyb3VwXzM5MjAiIGRhdGEtbmFtZT0iR3JvdXAgMzkyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU4Mi43NDYgLTI0NC44MjQpIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjMwMyIgZGF0YS1uYW1lPSJQYXRoIDIzMDMiIGQ9Ik01OTguNzMzLDI2Mi41NTJhMy4xNjcsMy4xNjcsMCwwLDAtMy4xODEsMy4xNTJ2MTAuNWEzLjE2NiwzLjE2NiwwLDAsMCwzLjE4MSwzLjE1MWgxOC4wMjZhMy4xNjYsMy4xNjYsMCwwLDAsMy4xOC0zLjE1MlYyNjUuN2EzLjE2NSwzLjE2NSwwLDAsMC0zLjE4LTMuMTUxWiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZTYyYTMyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMS41MDYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjMwNCIgZGF0YS1uYW1lPSJQYXRoIDIzMDQiIGQ9Ik02MTkuOTM5LDI2Ny44MjRINjE3LjE2YTMuMTMxLDMuMTMxLDAsMCwwLTMuMTMxLDMuMTMyaDBhMy4xMzEsMy4xMzEsMCwwLDAsMy4xMzEsMy4xMzFoMi43NzltLTIxLjA5MS0xMS41MzUsMTAuODc5LTUuODhhMy4xNywzLjE3LDAsMCwxLDQuMywxLjI4M2MuMDE4LjAzMi4wMzUuMDY1LjA1MS4xbDIuMjQxLDQuNW0tOS41ODIsMCw3LjM3My0zLjk5MyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZTYyYTMyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMS41MDYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjMwNSIgZGF0YS1uYW1lPSJQYXRoIDIzMDUiIGQ9Ik01OTUuNTc3LDI2NS41MTh2LTEuMDQ0YTUuMjI2LDUuMjI2LDAsMCwxLDUuMjM0LTUuMjE3aDMuNThtMTUuNTQ4LDYuMjYxdi0xLjA0NGE1LjI0Niw1LjI0NiwwLDAsMC01LjI3My01LjIxNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZTYyYTMyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIxLjUwNiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };